import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../../../components/text/text';
import { TextComponentType } from '../../../components/text/types/component';
// styles
import { HelpMessageWrapperStyled } from '../input.styled';
export const HelpMessageStandAlone = (props) => {
    if (!props.helpMessage?.content) {
        return null;
    }
    return (_jsx(HelpMessageWrapperStyled, { align: props.styles?.helpMessage?.text_align, id: props.helpMessageId, styles: props.styles, children: _jsx(Text, { component: TextComponentType.PARAGRAPH, customTypography: props.styles?.helpMessage, ...props.helpMessage, children: props.helpMessage.content }) }));
};
//# sourceMappingURL=helpMessage.js.map